import { useStaticQuery, graphql } from "gatsby"

export const useBuildData = () => {
  const { allGatsbyBuildConfiguration } = useStaticQuery(
    graphql`
      query {
        allGatsbyBuildConfiguration {
          edges {
            node {
              site_settings {
                display_contact_form
                display_rendez_vous
                display_deliberations
                email
                facebook_url
                website_name
                alert_message {
                  value
                }
                notification_popup_auto_opening
                notification_popup {
                  value
                }
                webpush_public_key
                webpush_enabled
                seo {
                  description_tag
                  title_tag
                }
                header_banner {
                  fid
                  uri
                }
                favicon {
                  fid
                  uri
                }
                instagram_url
                linkedin_url
                twitter_url
                website_logo {
                  fid
                  uri
                }
                youtube_url
              }
              theme_settings {
                typography_heading
                typography_text
                events_calendar
                palette {
                  a_color_gradients {
                    a_dark
                    a_medium
                    a_light
                  }
                  b_color_gradients {
                    b_dark
                    b_light
                  }
                  c_color_gradients {
                    c_dark
                    c_medium
                  }
                  d_color_gradients {
                    d_dark
                  }
                }
              }
              mentions_settings {
                legal_mentions_sup {
                  value
                }
                adress_social_name
                director_publication
                director_redaction
                info_accessibility {
                  value
                }
                info_cookies_sup {
                  value
                }
                legal_form
                mail_adress
                official_web_site
                phone_number
                social_capital
                social_name
              }
              rgpd_settings {
                data_manager
                delegated_data_protection
                list_treatments {
                  value
                }
                mail_data_manager
                mail_data_protection
                phone_data_manager
                phone_data_protection
              }
            }
          }
        }
      }
    `
  )
  return allGatsbyBuildConfiguration.edges[0].node
}
